module.exports = __webpack_public_path__ + "static/media/bullseye.7976a0d5.svg";